<template>
  <sea-page title="Dettaglio cud" showCompanyHeader back>
    <v-tabs>
      <v-tabs-slider></v-tabs-slider>

      <v-tab color="primary" key="1">
        <!-- <v-icon left>mdi-inbox</v-icon> -->
        Info e commenti
      </v-tab>
      <v-tab key="2">
        <!-- <v-icon left>mdi-text-box</v-icon> -->
        Dettagli
      </v-tab>
      <v-tab-item>
        <v-card flat><doc-preview :data="cud" /></v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat><cud-detail :cud="cud" /></v-card>
      </v-tab-item>
    </v-tabs>
  </sea-page>
</template>

<script>
import { mapActions } from "vuex";
import CudDetail from "./CudDetail.vue";
import DocPreview from "@/components/DocPreview.vue";

export default {
  name: "doc-lav",
  components: {
    CudDetail,
    DocPreview,
  },
  beforeRouteEnter(to, _, next) {
    next(async (vm) => {
      vm.cud = await vm.fetchById(to.query.id);
    });
  },
  data() {
    return {
      cud: null,
    };
  },
  methods: {
    ...mapActions({
      fetchById: "docsLav/fetchCudById",
    }),
  },
};
</script>

<style>
</style>